import { render, staticRenderFns } from "./HStudentLeaveSubCreate.vue?vue&type=template&id=bedb7148&scoped=true&"
import script from "./HStudentLeaveSubCreate.vue?vue&type=script&lang=js&"
export * from "./HStudentLeaveSubCreate.vue?vue&type=script&lang=js&"
import style0 from "./HStudentLeaveSubCreate.vue?vue&type=style&index=0&id=bedb7148&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedb7148",
  null
  
)

export default component.exports